// src/api/paytr.ts

import { postRequest } from "./postRequest";

export type PaytrTokenResponse = {
  success: boolean;
  errorCode?: string | null;
  errorDetail?: string | null;
  data?: {
    token: string;
    paymentAmount: number; // kuruş
    currency: string;
    testMode: boolean;
  } | null;
};

export type PaytrCreateTokenFromCartRequest = {
  // Sepet kimliği (sende var olan Identify ile aynı mantık)
  sepetId?: number | null;
  musteriId?: number | null;
  ziyaretciAnahtari?: string | null;

  // PAYTR zorunlu alanları
  merchantOid?: string;   // benzersiz sipariş no; boşsa server GUID oluşturabilir
  email: string;
  userIp?: string;        // backend’de boşsa Request’ten alsın (önerilir)

  // opsiyonel müşteri bilgileri
  userName?: string | null;
  userAddress?: string | null;
  userPhone?: string | null;

  // ödeme ayarları
  testMode?: boolean;
  noInstallment?: boolean;
  maxInstallment?: number | null;
  currency?: string | null;
  debugOn?: boolean;

  faturaAdresiJson?: string | null;
  teslimatAdresiJson?: string | null;
  notlar?: string | null;

  // dönüş sayfaları (bilgilendirme amaçlı)
  okUrl: string;
  failUrl: string;
};

export const paytrApi = {
  createTokenFromCart: (body: PaytrCreateTokenFromCartRequest) =>
postRequest<any,PaytrTokenResponse>("/odeme/paytr/get-token-from-cart", body),
};
